export const getFormattedDateString = (date) => {
    const pageLang = document.documentElement.lang;

    const localeMap = {
        en: "en-US",
        sl: "sk-SK",
        de: "de-DE",
    };

    const localeOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
    };

    const locale = localeMap[pageLang] || "de-DE";

    return new Date(date).toLocaleDateString(locale, localeOptions).toString();
};
